import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom'; // <-- Wichtig
import socket from '../socket'; // Dein Client-Socket
import { getTeamIdFromPlayer } from '../utils/player';
import { isValidHttpUrl } from '../utils/url';
import Button from './ui/Button';
import Input from './ui/Input';
import Card from './ui/Card';
import useSocketEvent from '../utils/useSocketEvent';
import safeStorage from '../utils/safeStorage';

function Login() {
    const [formData, setFormData] = useState({ name: '', link: '' });
    const [isModerator, setIsModerator] = useState(false);
    const [modPassword, setModPassword] = useState('');
    const navigate = useNavigate(); // <-- Hook aus react-router-dom

    const handleLoginSuccess = useCallback(({ player, isModerator }) => {
        // Fallback: falls Server isModerator nicht korrekt sendet (z.B. alter Server),
        // teamInfo.name als zusätzliche Quelle nutzen.
        const resolvedIsModerator =
            isModerator === true ||
            (typeof player?.teamInfo?.name === 'string' &&
                player.teamInfo.name.toLowerCase() === 'moderator');

        console.log('Login erfolgreich!', player, 'Moderator?', resolvedIsModerator);

        safeStorage.setItem('playerId', player.id);
        safeStorage.setItem('isModerator', resolvedIsModerator ? '1' : '0');

        const normalizedTeamId = getTeamIdFromPlayer(player);
        if (normalizedTeamId) {
            console.log('[Login] Speichere teamId in localStorage:', normalizedTeamId);
            safeStorage.setItem('teamId', normalizedTeamId);
        } else {
            safeStorage.removeItem('teamId');
        }

        if (resolvedIsModerator) {
            navigate('/dashboard/home');
        } else {
            navigate('/show');
        }
    }, [navigate]);

    const handleLoginError = useCallback((err) => {
        console.error('Login fehlgeschlagen:', err);
        alert(err.message || 'Fehler beim Login');
    }, []);

    useSocketEvent(socket, 'loginSuccess', handleLoginSuccess);
    useSocketEvent(socket, 'loginError', handleLoginError);

    // Eingabefelder
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // Toggle "Moderator?"
    const handleModeratorToggle = () => {
        setIsModerator((prev) => {
            const next = !prev;
            if (!next) {
                setModPassword('');
            }
            return next;
        });
    };

    // Anmelden
    const normalizeLink = (rawLink) => {
        if (!rawLink) {
            return null;
        }

        const trimmed = rawLink.trim();
        if (!trimmed) {
            return null;
        }

        if (!isValidHttpUrl(trimmed)) {
            return null;
        }

        return trimmed;
    };

    const handleLogin = () => {
        const storedPlayerId = safeStorage.getItem('playerId');
        const normalizedLink = normalizeLink(formData.link);
        socket.emit('playerLogin', {
            playerId: storedPlayerId || null,
            name: formData.name,
            link: normalizedLink,
            isModerator,
            modPassword,
        });
    };


    return (
        <div className="auth-page">
            <div className="quiz-title-wrap">
                <h1 className="quiz-title neon-title">Besserwisser ?</h1>
            </div>
            <Card className="auth-card" title="Willkommen zurück" subtitle="Melde dich für Besserwisser ? an">
                <div className="auth-form">
                    <Input
                        id="name"
                        name="name"
                        label="Name"
                        placeholder="Dein Name"
                        value={formData.name}
                        onChange={handleInputChange}
                        helper="Dieser Name wird in der Show angezeigt."
                    />

                    <Input
                        id="link"
                        type="url"
                        name="link"
                        label="Liveansicht-Link"
                        placeholder="https://..."
                        value={formData.link}
                        onChange={handleInputChange}
                        helper="Optional. Stelle sicher, dass die URL korrekt ist."
                    />

                    <div className="toggle-row">
                        <button
                            type="button"
                            className={`toggle-button ${isModerator ? 'is-on' : ''}`}
                            role="switch"
                            aria-checked={isModerator}
                            onClick={handleModeratorToggle}
                        >
                            <span className="toggle-indicator" aria-hidden="true" />
                            <span className="toggle-label">Als Moderator anmelden</span>
                        </button>
                    </div>

                    {isModerator && (
                        <Input
                            id="modPassword"
                            type="password"
                            label="Moderator-Passwort"
                            value={modPassword}
                            onChange={(e) => setModPassword(e.target.value)}
                        />
                    )}

                    <Button variant="primary" size="lg" onClick={handleLogin} aria-label="Anmelden">
                        Anmelden
                    </Button>
                    <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => navigate('/show')}
                        aria-label="Als Zuschauer beitreten"
                    >
                        Als Zuschauer beitreten
                    </Button>
                </div>
            </Card>
        </div>
    );
}

export default Login;
